import React from 'react';
import image from './images/cursom.jpeg'

const CursoCard = ({ title, description, url }) => {
  return (
    <div 
      className="bg-white rounded-lg curso-card cursor-pointer transform transition-transform duration-200 hover:scale-105"
      onClick={() => window.open(url)}
    >
      <img src={image} alt={title} className="w-full h-48 object-cover rounded-t-lg" />
      <div className="p-4">
        <h3 className="text-lg font-bold text-gray-700">{title}</h3>
        <p className="text-gray-600 text-sm">{description}</p>
      </div>
    </div>
  );
};

export default CursoCard;